import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-condition-page',
  templateUrl: './service-condition-page.component.html',
  styleUrls: ['./service-condition-page.component.css']
})
export class ServiceConditionPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
